import YVSNHeaderLogo from "../assets/custom/YVSN_EMBLEM_COLOR.svg";
import {useState, useEffect} from "react";
import "../styles/menu-animations.css";
import "../styles/header-transparent.css";

const Header = () => {

    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    // Lock body scroll when menu is open
    useEffect(() => {
        if (menuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        // Cleanup on unmount
        return () => {
            document.body.style.overflow = '';
        };
    }, [menuOpen]);

    // Track scroll position for header background
    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const menuItems = [
        { href: "/", label: "Home", current: true },
        { href: "/about", label: "About" },
        { href: "/articles", label: "Articles" },
        { href: "/projects", label: "Client Projects" },
        { href: "/pricing", label: "Pricing" },
        { href: "/contact", label: "Contact Us" },
    ];

    return (
        <div data-animation="default" className={`header-wrapper w-nav header-transparent ${scrolled ? 'header-scrolled' : ''}`} data-easing2="ease-out-sine"
             data-easing="ease-out-sine" data-collapse="all" data-w-id="e5acff6c-5c21-62ec-86e5-c6f09f07f69e"
             role="banner" data-no-scroll="1" data-duration="0" data-doc-height="1">
            <div className="container-default w-container">
                {menuOpen && (
                    <nav role="navigation" className="header-nav-menu-wrapper hamburger-desktop w-nav-menu menu-animate-in menu-fullscreen">
                        <div className="header-menu-bg menu-bg-fade"></div>
                        <div className="menu-content-container">
                        <div className="header-nav-menu top menu-content-slide">
                            <ul className="header-nav-menu-list hamburger-desktop">
                                {menuItems.map((item, index) => (
                                    <li 
                                        key={item.href}
                                        className="header-nav-list-item hamburger-desktop menu-item-reveal"
                                        style={{ animationDelay: `${0.1 + index * 0.08}s` }}
                                    >
                                        <a
                                            href={item.href}
                                            aria-current={item.current ? "page" : undefined}
                                            className={`header-nav-link w-nav-link${item.current ? ' w--current' : ''}`}
                                        >
                                            {item.label}
                                            <span className="line-square-icon link-icon-right large"></span>
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="header-nav-menu bottom menu-social-reveal">
                            <div className="w-layout-grid social-media-grid center">
                                <a href="https://facebook.com/" target="_blank"
                                   className="social-icon w-inline-block social-icon-pop" style={{ animationDelay: '0.5s' }} rel="noreferrer">
                                    <div className="social-icon-font"></div>
                                </a>
                                <a href="https://twitter.com/" target="_blank"
                                   className="social-icon w-inline-block social-icon-pop" style={{ animationDelay: '0.55s' }} rel="noreferrer">
                                    <div className="social-icon-font"></div>
                                </a>
                                <a href="https://www.instagram.com/" target="_blank"
                                   className="social-icon w-inline-block social-icon-pop" style={{ animationDelay: '0.6s' }} rel="noreferrer">
                                    <div className="social-icon-font"></div>
                                </a>
                                <a href="https://www.linkedin.com/" target="_blank"
                                   className="social-icon w-inline-block social-icon-pop" style={{ animationDelay: '0.65s' }} rel="noreferrer">
                                    <div className="social-icon-font"></div>
                                </a>
                            </div>
                        </div>
                        </div>
                    </nav>
                )}
                <div className="header-content-wrapper" style={{ position: 'relative', zIndex: menuOpen ? 1001 : 'auto' }}>
                    <a href="/" aria-current="page"
                       className="header-logo-link w-nav-brand w--current"><img
                        src={YVSNHeaderLogo}
                        alt="Younivision Logo"/></a>
                    <div className="header-right-content">
                        <a data-w-id="e5acff6c-5c21-62ec-86e5-c6f09f07f6d8" href="mailto:hello@younivision.com"
                           className="link-wrapper hidden-on-tablet w-inline-block"
                           style={{ display: menuOpen ? 'none' : undefined }}>
                            <div className="link-text">HELLO@YOUNIVISION.com</div>
                            <div className="line-square-icon link-icon-right"></div>
                        </a>

                        <div onClick={() => setMenuOpen(!menuOpen)} data-w-id="e5acff6c-5c21-62ec-86e5-c6f09f07f6dd"
                             className={`hamburger-menu-wrapper w-nav-button ${menuOpen ? 'menu-open' : ''}`}
                             style={{userSelect: 'text'}}
                             aria-label={menuOpen ? "close menu" : "open menu"} 
                             role="button" 
                             tabIndex="0" 
                             aria-controls="w-nav-overlay-0"
                             aria-haspopup="menu" 
                             aria-expanded={menuOpen}>
                            <div className="hamburger-menu-bar top" style={{width: '50px'}}></div>
                            <div className="hamburger-menu-bar center" style={{width: '50px'}}></div>
                            <div className="hamburger-menu-bar bottom" style={{width: '50px'}}></div>
                            <div className="hamburger-menu-bar top-left">
                                <div className="hamburger-menu-bar-filler first"></div>
                            </div>
                            <div className="hamburger-menu-bar bottom-left">
                                <div className="hamburger-menu-bar-filler last"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-nav-overlay" data-wf-ignore="" id="w-nav-overlay-0"></div>
        </div>
    )

}

export default Header;
